import 'isomorphic-fetch';
import get from 'lodash/get';
import ApiSourcesError from './ApiSourcesError';
import { buildQueryParamsString, applyPathParamsToUrl, buildMetricsData } from '../common/utils';
import trovitAPI from '../api';
import { API_SOURCES_NAME, API_END_POINTS } from './apiSourcesConstants';
import clientConfig from '../../../parameters/client/config';
import handleApiResponse from '../common/handleApiResponses/trovitFetchResponse';

const ApiSources = Object.create(trovitAPI);
const API_GET_SOURCES_EXPIRED_TIME = 86400;

ApiSources.apiName = API_SOURCES_NAME;
ApiSources.ApiServiceError = ApiSourcesError;
ApiSources.fetchSources = function fetchSources({ countryCode, verticalId, verticalName }) {
  const resource = `${clientConfig.sourcesApi}${API_END_POINTS.FETCH_SOURCES}`;
  const queryParamsString = buildQueryParamsString({ countryCode, verticalId });
  const url = `${resource}?${queryParamsString}`;

  const metricsData = buildMetricsData(verticalName, countryCode, 'sources', 'topPlayers');

  return handleApiResponse(
    this.trovitFetch(url, 'GET', undefined, {
      headers: {
        ...this.config.headers,
        'Cache-Control': `max-age=${API_GET_SOURCES_EXPIRED_TIME}`,
      },
    }),
    metricsData
  )
    .then(response => response)
    .catch(error => {
      throw error;
    });
};

ApiSources.saveApply = function saveApply({ ad, config, userData }) {
  const resource = `${clientConfig.sourcesApi}${API_END_POINTS.SAVE_APPLY}`;
  const url = applyPathParamsToUrl(resource, { adId: ad.id });
  const body = {
    data: {
      type: 'lead',
      attributes: {
        ad: {
          title: ad.title,
          url: window.location.href,
        },
        sourceAd: {
          id: get(ad, ['source', 'ad', 'id']),
          url: get(ad, ['source', 'ad', 'url']),
          email: get(ad, ['source', 'ad', 'contactEmail']),
          source: {
            id: get(ad, ['source', 'id']),
            countryCode: config.countryCode,
            verticalId: config.verticalId,
          },
        },
        ...userData,
      },
    },
  };

  return this.trovitFetch(url, 'POST', body);
};

export default ApiSources;



// WEBPACK FOOTER //
// ./app/sdk/sources/ApiSources.js